import s from './MineSquadNew.module.sass';
import React, { FC, useCallback, useRef, useState } from 'react';
import { Button, Form, FormItem, Header, ScrollView } from '$uikit';
import { IcUpload28 } from '$assets';
import { AttachPickerManagerRef } from '$shared/components/AttachPickerManager/AttachPickerManager.interface';
import AttachPickerManager from '$shared/components/AttachPickerManager/AttachPickerManager';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '$store/rootReducer';
import { attachActions, attachItemsSelector, attachPhotosSelector } from '$store/attach';
import { useTranslator } from '$hooks';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { goTo } from '$navigation/helper';
import { MINE_SQUAD } from '$shared/constants/pages';

export const MineSquadNew: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const pickerId = 'mine_squad';
  const [inputKey, setInputKey] = useState(0);
  const attachManager = useRef<AttachPickerManagerRef | null>(null);
  const mediaAttachments = useSelector((state: RootState) =>
    attachPhotosSelector(state, pickerId),
  );
  const attachMedia = useSelector((state: RootState) =>
    attachItemsSelector(state, pickerId),
  );

  const handlePhotoChange = useCallback(
    async ({ target: { files } }: React.ChangeEvent<HTMLInputElement>) => {
      if (!files) return;
      dispatch(attachActions.clear(pickerId));
      attachManager.current?.uploadImages(files);
      setInputKey(Date.now());
    },
    [attachManager, setInputKey],
  );

  const handleSave = () => {
    dispatch(toastActions.setToastLoading());
    Api.post<any, any>('/mine/squad/update', {
      // @ts-ignore
      photoId: attachMedia[0].photo!.photoId,
    })
      .then((data) => {
        dispatch(toastActions.setToastSuccess());
        goTo(
          MINE_SQUAD,
          {
            id: data.id,
          },
          {
            replace: true,
          },
        );
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
      });
  };

  return (
    <>
      <Header showCloseButton>{t('new_squad_title')}</Header>
      <ScrollView
        footer={
          mediaAttachments.length > 0 &&
          attachMedia.length > 0 &&
          attachMedia !== 'photo_uploading' && (
            <Button onClick={handleSave}>{t('save')}</Button>
          )
        }
      >
        <Form>
          <FormItem title={t('new_squad_photo')} description={t('new_squad_photo_info')}>
            <div className={s.photoInfo}>{t('new_squad_photo_info2')}</div>
            <div className={s.requirements}>
              <div className={s.requirementsTitle}>
                {t('new_squad_photo_requirements')}:
              </div>
              <div className={s.requirementsItem}>
                {t('new_squad_photo_requirements1')}
              </div>
              <div className={s.requirementsItem}>
                {t('new_squad_photo_requirements2')}
              </div>
              <div className={s.requirementsItem}>
                {t('new_squad_photo_requirements3')}
              </div>
              <div className={s.requirementsItem}>
                {t('new_squad_photo_requirements4')}
              </div>
            </div>
            <div className={s.button}>
              <Button icon={<IcUpload28 />} mode="secondary">
                {t('new_squad_photo_upload')}
              </Button>
              <input
                key={inputKey}
                onChange={handlePhotoChange}
                multiple
                accept="image/*"
                type="file"
              />
            </div>
          </FormItem>
          <FormItem>
            <AttachPickerManager
              watermark={false}
              ref={attachManager}
              pickerId={pickerId}
            />
          </FormItem>
        </Form>
      </ScrollView>
    </>
  );
};
